<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Приоретизация камер</h2>
        <priorities-table
          ref="prioritiesTable"
          :priorities="items"
          :is-deleting-transaction="isDeletingTransaction"
          :remove-transaction="deleteTransaction"
        />
        <el-pagination
          hide-on-single-page
          class="list__pagination"
          layout="prev, pager, next"
          :page-size="count"
          :total="total"
          :current-page="page"
          @current-change="changePage"
        />
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button
        class="page__active_button"
        icon="el-icon-plus"
        type="primary"
        @click="openDialog"
      >
        Указать приоритет
      </el-button>
    </el-footer>
    <add-priority-dialog
      :visible.sync="showAddPriorityDialog"
      :loading.sync="isAddingPriority"
      :save-priority="savePriority"
    />
  </el-container>
</template>
  
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import PrioritiesTable from "@/components/Priorities/PrioritiesTable";
import AddPriorityDialog from "@/components/Priorities/dialogs/AddPriorityDialog";
import list from "@/core/mixins/list";

export default {
  name: "Priorities",
  components: {
    PrioritiesTable,
    AddPriorityDialog,
  },
  mixins: [list],
  data() {
    return {
      isAddingPriority: false,
      isDeletingTransaction: false,
      showAddPriorityDialog: false,
    };
  },
  computed: {
    ...mapState("priorities", {
      items: (state) => state.priorities.data,
      total: (state) => state.priorities.total,
      count: (state) => state.priorities.count,
    }),
  },
  created() {
    this.setList({
      data: [],
      total: 0,
      count: 10,
    });
  },
  methods: {
    savePriority(priority) {
      this.isAddingPriority = true;

      this.addPriority(priority)
        .then(() => {
          this.loadData();
          this.closeDialog();
        })
        .catch(() => {
          this.$message({
            message: 'Произошла ошибка при указании приоритета',
            type: 'error'
          })
        })
        .finally(() => {
          this.isAddingPriority = false;
        });
    },
    deleteTransaction(transaction) {
      this.$confirm(
        `Удалить транзакцию с указанием приоритета ${transaction.priority}
        для ${transaction.type}? (id транзакции: ${transaction.id_transaction})`,
        'Удаление',
        {
          confirmButtonText: 'Удалить',
          type: 'warning'
        }
      )
        .then(() => { this.isDeletingTransaction = true })
        .then(() => this.removeTransaction(transaction.id_transaction))
        .then(() => this.loadData())
        .then(() => this.$message({
          message: 'Транзакция успешно удалена',
          type: 'success'
        }))
        .catch(() => this.$message({
          message: 'При удалении транзакции произошла ошибка',
          type: 'error'
        }))
        .finally(() => { this.isDeletingTransaction = false });
    },
    openDialog() {
      this.showAddPriorityDialog = true;
    },
    closeDialog() {
      this.showAddPriorityDialog = false;
    },
    ...mapActions("priorities", {
      getList: "GET_PRIORITIES",
      addPriority: "ADD_PRIORITY",
      removeTransaction: 'REMOVE_PRIORITY_TRANSACTION'
    }),
    ...mapMutations("priorities", {
      setList: "SET_LIST_PRIORITIES",
    }),
  },
};
</script>
  